import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../_services";
import {Role} from "../../helpers";

@Component({
    standalone: false,
  selector: 'app-support-login',
  templateUrl: './support-login.component.html',
})
export class SupportLoginComponent implements OnInit {

  constructor(public router: Router,
              public route: ActivatedRoute,
              public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.authenticationService.loginSupport(p['i']).subscribe(r => {
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        let returnUrl = this.route.queryParams['value']['returnUrl'];
        if (returnUrl) {
          this.router.navigateByUrl(returnUrl);
        } else if (currentUser.role == Role.KingAdmin) {
          this.router.navigate(['/tenants']);
        } else if (currentUser.role == Role.Training) {
          this.router.navigate(['/training']);
        } else if (currentUser.role == Role.Survey) {
          this.router.navigate(['/assessments']);
        } else {
          this.router.navigate(['']);
        }
      });
    });
  }

}
